import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
/**
 * @class EncryptService
 * @description This is a service which provide decrypt algorithm
 */
@Injectable({ providedIn: 'root' })
export class EncryptService {
  /**
   * @function decryptUsingAES128
   * @description The function provides decrypt algorithm using AES 128
   * @param {string} cipher
   * @param {string} cryptoKey
   * @return {string}
   */
  decryptUsingAES128(cipher: string, cryptoKey: string): string {
    const key = CryptoJS.enc.Utf8.parse(cryptoKey);
    return CryptoJS.AES.decrypt(cipher, key, {
      keySize: 16,
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    }).toString(CryptoJS.enc.Utf8);
  }

  encryptUsingAES128(text: string, cryptoKey: string): string {
    const key = CryptoJS.enc.Utf8.parse(cryptoKey);
    return CryptoJS.AES.encrypt(text, key, {
      keySize: 16,
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    }).toString();
  }
}
